import React from "react"
import FormHelperText, { FormHelperTextProps } from "@material-ui/core/FormHelperText"

export interface IFormErrorText extends Omit<FormHelperTextProps, "error"> {}

const FormErrorText: React.FC<IFormErrorText> = ({ children, ...props }) => (
  <FormHelperText error={true} {...props}>
    {children}
  </FormHelperText>
)

export default FormErrorText
